import type { IFetchService } from "app/services/fetchService";
import { NoCacheHeaders } from "app/services/fetchService";
import { ContactsSearchProfilesEndpoint, PROFILE_ID_PLACEHOLDER } from "../constants/api";
import type { ProfileDto } from "../types/dto";
import type {
    ProfilesResponseDto,
    CreateProfileResponseDto,
    CreateProfileRequestDto,
    UpdateProfileRequestDto,
    UpdateProfileResponseDto,
} from "../types/dto";

export default function createContactsSearchProfilesApi(fetchService: IFetchService) {
    function replaceIdPlaceholder(id: ProfileDto["id"], path: string) {
        return path.replace(PROFILE_ID_PLACEHOLDER, id);
    }

    return {
        fetchAllProfiles(): Promise<ProfilesResponseDto> {
            return fetchService.get(ContactsSearchProfilesEndpoint.GET_ALL, undefined, {
                headers: NoCacheHeaders,
            });
        },
        createProfile(dto: CreateProfileRequestDto): Promise<CreateProfileResponseDto> {
            return fetchService.post(ContactsSearchProfilesEndpoint.CREATE, dto);
        },
        updateProfile(dto: UpdateProfileRequestDto): Promise<UpdateProfileResponseDto> {
            return fetchService.put(replaceIdPlaceholder(dto.id, ContactsSearchProfilesEndpoint.UPDATE), dto);
        },
        deleteProfile(id: ProfileDto["id"]): Promise<void> {
            return fetchService.delete(replaceIdPlaceholder(id, ContactsSearchProfilesEndpoint.DELETE));
        },
        excludeProfile(id: ProfileDto["id"]): Promise<void> {
            return fetchService.post(replaceIdPlaceholder(id, ContactsSearchProfilesEndpoint.EXCLUDE));
        },
    };
}
